import { render, staticRenderFns } from "./KdzGoodsConfigList.vue?vue&type=template&id=7248f59e"
import script from "./KdzGoodsConfigList.vue?vue&type=script&lang=js"
export * from "./KdzGoodsConfigList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports